<div class="themes-container">
    <p class="text-16-500 color-8 mb-0 ri-pb-4">{{ ss.t('colourSelect_chooseColour') }}</p>
    <div class="theme-colors">
        <div class="theme-color" *ngFor="let theme of themeColors()" role="button" (click)="selectTheme(theme.name, $event)" [class.selected]="selectedThemeColor() === theme.color" [style.border-color]="selectedThemeColor() === theme.color ? theme.color : 'transparent'">
            <div class="theme-color-inner" [style.background-color]="theme.color"></div>
        </div>
    </div>
</div>